import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2224_holiday_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Add Holiday",
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "holiday_list",
                TableName: "holiday_list",
                DisplayName: "Holiday",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                fieldVisibilityRules: [
                    {
                        when: {
                            field: "applicable_to",
                            label: "Specific Locations",
                        },
                        showFields: ["employee_groups"],
                    },
                ],
                childComponents: [
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "parent_id",
                        BindValue: "parent_id",
                        Json_Attribute: "parent_id",
                        style: { display: "none" },
                    } as any,
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "holiday_name",
                        label: "Holiday Name",
                        placeholder: "e.g. Diwali",
                        required: true,
                        maxLength: 255,
                        BindValue: "holiday_name",
                        Json_Attribute: "holiday_name",
                    } as any,
                    {
                        componentType: ComponentType.DATE_FIELD,
                        name: "holiday_date",
                        label: "Holiday Date",
                        required: true,
                        BindValue: "holiday_date",
                        Json_Attribute: "holiday_date",
                    } as any,
                    {
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        name: "holiday_type",
                        label: "Holiday Type",
                        placeholder: "Select Holiday Type",
                        required: false,
                        BindValue: "holiday_type",
                        Json_Attribute: "holiday_type",
                        options: [
                            { label: "National", value: "National" },
                            { label: "Festival", value: "Festival" },
                            { label: "Company Holiday", value: "Company Holiday" },
                            { label: "Optional Holiday", value: "Optional Holiday" },
                        ],
                    } as any,
                    {
                        componentType: ComponentType.RADIO_FIELD,
                        name: "applicable_to",
                        label: "Applicable To",
                        direction: FlexDirection.ROW,
                        defaultValue: "All Employees",
                        BindValue: "applicable_to",
                        Json_Attribute: "applicable_to",
                        options: [
                            { label: "All Employees", value: "All Employees" },
                            { label: "Specific Locations", value: "Specific Locations" },
                        ],
                    } as any,
                    {
                        componentType: ComponentType.SEARCHABLE_DROPDOWN,
                        name: "employee_groups",
                        label: "Select Locations",
                        placeholder: "Search and select locations...",
                        multiple: true,
                        lookupName: "branches",
                        searchable: true,
                        clearable: true,
                        BindValue: "employee_groups",
                        Json_Attribute: "employee_groups",
                        options: [],
                    } as any,
                    {
                        componentType: ComponentType.RADIO_FIELD,
                        name: "paid_holiday",
                        label: "Paid Holiday",
                        direction: FlexDirection.ROW,
                        defaultValue: 1,
                        BindValue: "paid_holiday",
                        Json_Attribute: "paid_holiday",
                        options: [
                            { label: "Yes", value: 1 },
                            { label: "No", value: 0 },
                        ],
                    } as any,
                    {
                        componentType: ComponentType.TEXT_AREA,
                        name: "description",
                        label: "Description",
                        placeholder: "e.g. Diwali celebration with lights and sweets.",
                        required: false,
                        rows: 3,
                        maxLength: 500,
                        BindValue: "description",
                        Json_Attribute: "description",
                    } as any,
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    justifyContent: "flex-end",
                    padding: 10,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Save",
                        onPressAction: "save",
                        style: {
                            backgroundColor: "var(--primary-green)",
                            widthMode: "wrap",
                        },
                    } as any,
                ],
            },
        ],
    },
];
